import { useCallback, useEffect, useState } from 'react';
import { Card, Form, InputGroup } from 'react-bootstrap';
import { Button } from '@Components/Button';
import { Dropdown } from '@Components/Dropdown';
import { DropdownOption } from '@Components/Dropdown/dropdown-constants';
import { Size } from '@src/Components/designConstants';
import {
  awaitJSON,
  SheetsLambdaFetch,
  StreamingUtilsLambdaFetch
} from '../../../utils/fetch-utils';
import { AdOpsToolProps } from '../adops-constants';

export const NexxenAdvertiserAdder = ({ utils }: AdOpsToolProps) => {
  const [activeAPICall, setActiveAPICall] = useState(false);
  const { setError } = utils;

  const [company, setCompany] = useState('');
  const [advertiserId, setAdvertiserId] = useState<number | null>(null);
  const [companyOptions, setCompanyOptions] = useState<string[]>();

  useEffect(() => {
    if (!companyOptions) {
      (async () => {
        try {
          const res = await SheetsLambdaFetch('/get_company_ids');
          const companies = await awaitJSON<{ ids: string[] }>(res);
          setCompanyOptions(companies.ids);
        } catch (e) {
          setError({ message: e.message, reportError: e });
        }
      })();
    }
  }, [companyOptions, setError]);

  const companyDropdownOptions: DropdownOption[] = (companyOptions ?? []).map(value => ({
    value,
    label: value
  }));

  const addNexxenAdvertiserId = useCallback(async () => {
    try {
      setActiveAPICall(true);
      await StreamingUtilsLambdaFetch('/addNexxenAdvertiserId', {
        method: 'POST',
        body: JSON.stringify({
          company,
          advertiserId
        })
      });
      setCompany('');
      setAdvertiserId(null);
    } catch (e) {
      setError({
        message: e.message,
        reportError: e
      });
    }
    setActiveAPICall(false);
  }, [company, advertiserId, setError]);

  return (
    <Card className='ad-ops-card' data-testid='nexxen-advertiser'>
      <div className='ad-ops-card-title'>Add Nexxen Advertiser</div>
      <div className='ad-ops-elem' data-testid='nexxen-company'>
        <Dropdown
          size={Size.LG}
          label='Company'
          placeholder='Select or type a company…'

          menuPortalTarget={document.body}
          searchable
          creatable
          clearable
          value={company || null}
          options={companyDropdownOptions}
          onChange={value => setCompany(value ?? '')}
          reactSelectProps={{ formatCreateLabel: input => `Use "${input}"` }}
        />
      </div>
      <InputGroup size='sm' className='ad-ops-elem'>
        <InputGroup.Text className='input-label'>Nexxen Advertiser Id</InputGroup.Text>
        <Form.Control
          value={advertiserId ?? ''}
          onChange={e => setAdvertiserId(e.target.value ? parseInt(e.target.value, 10) : null)}
          data-testid='nexxen-advertiser-id'
        />
      </InputGroup>
      <Button
        size={Size.LG}
        className='ad-ops-elem'
        loading={activeAPICall}
        onClick={addNexxenAdvertiserId}
        data-testid='nexxen-advertiser-add'
      >
        Add
      </Button>
    </Card>
  );
};
